import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { RESOURCES } from "../data/content";
import PageHero from "../components/PageHero";
import CtaBanner from "../components/CtaBanner";
import Icon from "../components/Icon";

function ResourceDetail() {
  const { slug } = useParams();
  const resource = RESOURCES.find((r) => r.slug === slug);

  if (!resource) return <Navigate to="/resources" replace />;

  return (
    <>
      <PageHero eyebrow="Resources" title={resource.title} subtitle={resource.detail} />

      <section className="section">
        <div className="container">
          <Link to="/resources" className="link-arrow">
            <Icon name="arrow" size={14} className="link-arrow-back" /> Back to all resources
          </Link>
        </div>
      </section>

      <CtaBanner
        eyebrow="Want the full documentation set?"
        title="Request the complete MPeoples HRMS documentation"
        subtitle="We'll share the full API reference, security notes, testing approach, deployment guide and troubleshooting playbook."
      />
    </>
  );
}

export default ResourceDetail;
